import { tieredPricingKeys } from '@capabilities/tiered-pricing/api/keys';
import { tieredPricingStore } from '@capabilities/tiered-pricing/store/tiered-pricing-store';
import type { QueryClient } from '@tanstack/react-query';
import type { ID } from 'types';

/**
 * A line-item save can change which tier groups collide, so the cached answer must not outlive it,
 * and a buyer who closed the warning is warned again on the next save that still has duplicates.
 */
export const invalidateTierConfigurationAfterSave = (queryClient: QueryClient, eventId: ID): void => {
  queryClient.invalidateQueries({ queryKey: tieredPricingKeys.configuration(eventId) });
  tieredPricingStore.resetDuplicateQuantityWarningDismissal();
};
